import React, { useEffect } from 'react';
import { Control, Controller } from 'react-hook-form';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from 'common/components/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { StoreBasicDataApiStructure } from 'common/types';
import { CheckoutType } from 'api/repositories';
import ErrorPanel from 'common/components/ErrorPanel';
import { PAYMENT_METHOD } from 'views/pages/Checkout/common/constants';
import { CheckoutValues } from 'store/ducks/checkout/types';
import { RadioLoader } from 'views/pages/Checkout/common/loaders';
import { Grid } from '@material-ui/core';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';

type Props = {
    cartToken: string;
    control: Control;
    checkoutData: StoreBasicDataApiStructure<CheckoutType>;
    checkoutValues: CheckoutValues;
    errors: any;
    fetchCheckoutData: Function;
};

const PaymentType: React.FC<Props> = ({
    cartToken,
    checkoutData,
    checkoutValues,
    control,
    errors,
    fetchCheckoutData,
}) => {
    const { isLoading } = checkoutData;
    const paymentMethods = checkoutData.data?.payments?.[0].methods;

    useEffect(() => {
        fetchCheckoutData(`checkout/${cartToken}/payment`);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Grid item xs={12}>
                {isLoading ? (
                    <RadioLoader />
                ) : (
                    <>
                        <Controller
                            as={RadioGroup}
                            control={control}
                            name={PAYMENT_METHOD}
                            defaultValue={checkoutValues.paymentMethod || ''}
                        >
                            {paymentMethods &&
                                Object.values(paymentMethods).map(({ code, description }) => (
                                    <FormControlLabel
                                        key={code}
                                        control={<Radio />}
                                        label={description}
                                        value={code}
                                    />
                                ))}
                        </Controller>
                        <ErrorPanel errors={errors} name={PAYMENT_METHOD} />
                    </>
                )}
            </Grid>
        </Grid>
    );
};

export default PaymentType;
